export const users = [
  {
    "id": 1,
    "id_card": 600502,
    "name": "Leanne",
    "last_name": "Graham",
    "username": "Bret",
    "password": "st_@1",
    "student_level": "sophomore",
    "permission": false,
  },
  {
    "id": 2,
    "id_card": 600123,
    "name": "Ervin",
    "last_name": "Howell",
    "username": "Antonette",
    "password": "st_@2",
    "student_level": "sophomore",
    "permission": false,
  },
  {
    "id": 3,
    "id_card": 590034,
    "name": "Clementine",
    "last_name": "Bauch",
    "username": "Samantha",
    "password": "st_@3",
    "student_level": "junior",
    "permission": false,
  },
  {
    "id": 4,
    "id_card": 580423,
    "name": "Nicholas",
    "last_name": "Runolfsdottir V",
    "username": "Maxime_Nienow",
    "password": "st_@4",
    "student_level": "senior",
    "permission": false,
  },
  {
    "id": 5,
    "id_card": 610988,
    "name": "Patricia",
    "last_name": "Lebsack",
    "username": "Karianne",
    "password": "st_@5",
    "student_level": "fresher",
    "permission": false,
  },
  {
    "id": 6,
    "id_card": 610150,
    "name": "Chelsey",
    "last_name": "Dietrich",
    "username": "Kamren",
    "password": "st_@6",
    "student_level": "freshman",
    "permission": false,
  },
  {
    "id": 7,
    "id_card": 580112,
    "name": "Dennis",
    "last_name": "Schulist",
    "username": "Leopoldo_Corkery",
    "password": "st_@7",
    "student_level": "senior",
    "permission": false,
  },
  {
    "id": 8,
    "id_card": 590502,
    "name": "Kurtis",
    "last_name": "Weissnat",
    "username": "Elwyn.Skiles",
    "password": "st_@8",
    "student_level": "junior",
    "permission": false,
  },
  {
    "id": 9,
    "id_card": 590740,
    "name": "Glenna",
    "last_name": "Reichert",
    "username": "Delphine",
    "password": "st_@9",
    "student_level": "junior",
    "permission": false,
  },
  {
    "id": 10,
    "id_card": 610367,
    "name": "Clementina",
    "last_name": "DuBuque",
    "username": "Moriah.Stanton",
    "password": "st_@10",
    "student_level": "freshman",
    "permission": false,
  },
  {
    "id": 99,
    "id_card": 99999,
    "name": "Jaruphat",
    "last_name": "Khenprom",
    "username": "demo",
    "password": "demo1",
    "student_level": "admin",
    "permission": true,
  },
]
  